// DEPENDENCIES ---------------------------------------------------------------- //

import React from 'react';

import { getComparator, stableSort } from '@services/utilityService';

const FOLD_GROUP_KEY = 'invoice-fold-group-key';
const getDefaultFoldGroupKey = (): string | null => localStorage.getItem(FOLD_GROUP_KEY);

import { TableBody } from '@mui/material';

import InvoiceDetailsTableRowCharges from '@features/invoices/components/InvoiceDetailsTableRowCharges';
import type { MoveTableColumn } from '@features/invoices/components/moveTableColumns';

// TYPES ---------------------------------------------------------------- //

type InvoiceDetailsTableBodyChargesProps = {
  rows: any[];
  order: string;
  orderBy: string;
  page: number;
  rowsPerPage: number;
  handleDisputeModalOpen: any;
  invoice?: any;
  hasMoveCharges?: boolean;
  hasDistance?: boolean;
  hiddenColumns?: ReadonlySet<MoveTableColumn>;
  hasGuestrides?: boolean;
};

// COMPONENT ---------------------------------------------------------------- //

const InvoiceDetailsTableBodyCharges = ({
  rows,
  order,
  orderBy,
  page,
  rowsPerPage,
  handleDisputeModalOpen,
  invoice,
  hasMoveCharges,
  hasDistance,
  hiddenColumns,
  hasGuestrides,
}: InvoiceDetailsTableBodyChargesProps) => {
  const [foldId, setFoldId] = React.useState<string | null>(getDefaultFoldGroupKey());

  // Add sorting values for special columns
  const rowsWithSortValues = rows.map(row => ({
    ...row,
    _sortDistance: row.moveGroup?.move?.lane?.distance_miles || 0,
    _sortCost: row.moveGroup?.total || 0,
  }));

  return (
    <TableBody>
      {stableSort(
        rowsWithSortValues,
        getComparator(order, orderBy === 'DISTANCE' ? '_sortDistance' : orderBy === 'COST' ? '_sortCost' : orderBy)
      )
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row: any, i: number) => {
          return (
            <React.Fragment key={`invoice-row-${row?.moveGroup?.groupKey}`}>
              <InvoiceDetailsTableRowCharges
                row={row}
                index={page * rowsPerPage + i}
                foldId={foldId}
                setFoldId={setFoldId}
                handleDisputeModalOpen={handleDisputeModalOpen}
                invoice={invoice}
                hasMoveCharges={hasMoveCharges}
                hasDistance={hasDistance}
                hiddenColumns={hiddenColumns}
                hasGuestrides={hasGuestrides}
              />
            </React.Fragment>
          );
        })}
    </TableBody>
  );
};

// EXPORT ---------------------------------------------------------------- //

export default InvoiceDetailsTableBodyCharges;
